import { render, staticRenderFns } from "./dingdingitem.vue?vue&type=template&id=0c3a0e34&scoped=true&"
import script from "./dingdingitem.vue?vue&type=script&lang=js&"
export * from "./dingdingitem.vue?vue&type=script&lang=js&"
import style0 from "./dingdingitem.vue?vue&type=style&index=0&id=0c3a0e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a0e34",
  null
  
)

export default component.exports